export const RiskStatus  = {
  'New RA' : 0,
  'Approved' : 1,
  'For Approval' : 2,
}